import Metrics from './Metrics'

export function getHttpErrorReason(res) {
    return (res && res.response && res.response.data) ? res.response.data.error : res.message;
}

export function httpFailed(call, commit, result) {
    const msg = httpError(result);
    Metrics.error('http failed ' + call + ' result ' + httpError(msg))
}

export function httpError(result) {
    if (typeof result == "string") {
        return result;
    }
    const response = result?.response;
    if (!response) {
        if (result?.message) {
            if ($build.mode == 'development') {
                console.error(result);
            }
            return result.message;
        }
        return 'unknown error';
    } else if (response?.data?.error) {
        return response.data.error;
    } else if (response?.status == 500) {
        return `error: ${response.status} | ${response.statusText}`;
    } else if (response?.status == 408) {
        return `error: The system is unable to complete your request at this time.`;
    } else if (response?.statusText) {
        return `error: ${response.status} | ${response.statusText}`;
    } else {
        return `unknown error ${response}`;
    }
}

export function httpStatus(result) {
    return result?.response?.status || 0
}

